import { NumberInput } from '@snsw/react-component-library';
import FieldError from 'components/FieldError';
import { QuestionConditionals } from 'components/Question/components/QuestionConditionals';
import styled from 'styled-components';
import { NumberQuestionProps, QuestionProps } from '../types';
import { ForwardedRef, forwardRef } from 'react';
import { getLabelText } from './getLabelText';

type Props = QuestionProps<number> & NumberQuestionProps;

// The Kiama number input has a lot of superfluous styling that we need to remove
const Container = styled.div`
  *[class^='MainContainer'] {
    box-shadow: none;
    padding: 0;
    height: auto;
  }
`;

export const NumberQuestion = forwardRef(
  (
    {
      label,
      helpMessage,
      optional,
      value,
      onChange,
      errorMessage,
      supportingDocuments,
      conditionalMessages,
      ...numberInputProps
    }: Props,
    ref: ForwardedRef<HTMLInputElement>
  ) => {
    const title = getLabelText(label, optional);

    const fieldValue = value == null ? 0 : value;
    const handleChange = (next: string) => onChange(parseInt(next, 10));

    return (
      <Container>
        <NumberInput
          {...numberInputProps}
          title={title}
          moreInfoHelpText={helpMessage}
          inputRef={ref}
          value={fieldValue}
          onChange={handleChange}
        />

        {!!errorMessage && <FieldError message={errorMessage} />}

        <QuestionConditionals
          value={fieldValue}
          supportingDocuments={supportingDocuments}
          conditionalMessages={conditionalMessages}
        />
      </Container>
    );
  }
);
